var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RevisionsPanel',{attrs:{"resources":_vm.variables,"resource-key":_vm.resourceKey,"resource-has-unsaved-changes-present":_vm.hasUnsavedChangesPresent,"fetch-revisions-method":_vm.fetchRevisionsMethod,"update-method":"setVariables","restore-method":"restoreVariablesRevision"}})
}
var staticRenderFns = []

export { render, staticRenderFns }